import React from 'react';
import styles from './RoleTag.module.scss';

const ROLE_CLASS_MAP = {
  Admin: styles.admin,
  Manager: styles.manager,
  Member: styles.member,
  Client: styles.client,
};

export const ROLE_AVATAR_STYLE_MAP = {
  Admin: { background: 'var(--purple-100)', color: 'var(--purple-700)' },
  Manager: { background: 'var(--success-100)', color: 'var(--success-700)' },
  Member: { background: 'var(--blue-100)', color: 'var(--blue-700)' },
  Client: { background: 'var(--warning-100)', color: 'var(--warning-700)' },
};

export const RoleTag = ({ role }) => (
  <span className={`${styles.tag} ${ROLE_CLASS_MAP[role] || styles.default}`}>
    {role || 'N/A'}
  </span>
);
